import { GatewayApi } from "./base";

class HistoryImpl {
    constructor(
        readonly id: string,
        readonly entity: string,
        readonly action: string,
        readonly author: string,
        readonly created_at: string,
        readonly description?: string,
    ) {}
}

export interface HistoryInterface extends HistoryImpl {}

export class HistoryApi extends GatewayApi {
    constructor() {
        super("history");
    }

    index(
        page: number = 1,
        page_size: number = 15,
        filter_author: string | null = null,
        search_value: string | null = null,
    ): Promise<{ items: HistoryInterface[]; count: number }> {
        return this.invoke("index", { page, page_size, filter_author, search_value }) ?? { items: [], count: 0 };
    }

    removeOldRecords(){
        return this.invoke("remove_old_records")
    }

    getAllRedoneEvents(){
        return this.invoke("get_all_redone_events")
    }
}
